import { render, staticRenderFns } from "./SystemConfigDetails.vue?vue&type=template&id=32f58e10"
import script from "./SystemConfigDetails.vue?vue&type=script&lang=js"
export * from "./SystemConfigDetails.vue?vue&type=script&lang=js"
import style0 from "./SystemConfigDetails.vue?vue&type=style&index=0&id=32f58e10&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports